import { removeCookie } from '../../helpers/cookies';

/**
 * Action
 * User Success Logout
 */

const logout = () => {
    // removeCookie('auth');
    // removeCookie('activeLicense');
    return { type: 'LOGOUT_SUCCESS' };
};

export default logout;
